import _regeneratorRuntime from "@babel/runtime/regenerator";
var _jsxFileName = "/Users/michaelschlecht/Documents-CCM/dev/ccm-innovation/pricing-components/src/components/PricingCalculator/PricingCalculator.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Fragment } from "react";
import { PropTypes } from "prop-types";
import NumberFormat from "react-number-format";
import "./PricingCalculator.scss";
import * as SharedUtils from '../../utils/shared-utils';
import * as Utils from "../../utils/pricing-calculator-utils";
import { StatePicker } from '@ccm-innovation/address-components';

var PricingCalculator = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PricingCalculator, _Component);

  var _super = _createSuper(PricingCalculator);

  function PricingCalculator(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleUpdateZipCode", function (zipCode) {
      _this.props.debugMode && console.log('Updating Zip Code:', zipCode);
      return _this.setState({
        zipCode: zipCode
      }, function () {
        if (zipCode.length === 5 || _this.state.verified.zipCode !== null) _this.validateZipCode(zipCode);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateZipCode", function (zipCode) {
      var zipCodeValid = false; // remove mask characters

      zipCode = zipCode.replace('_', '');
      if (zipCode.length === 5) zipCodeValid = true;
      _this.props.debugMode && console.log("Zip Code Valid?", zipCodeValid);
      return _this.setState(function (prevState) {
        return {
          verified: _extends({}, prevState.verified, {
            zipCode: zipCodeValid
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdateState", function (state) {
      _this.props.debugMode && console.log('Updating State:', state);
      return _this.setState({
        state: state.length > 2 ? null : state
      }, function () {
        if (state.length === 2 || _this.state.verified.state !== null) _this.validateState(state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateState", function (state) {
      var stateValid = false;
      if (state && state !== "State") stateValid = true;
      _this.props.debugMode && console.log("State Valid?", stateValid);
      return _this.setState(function (prevState) {
        return {
          verified: _extends({}, prevState.verified, {
            state: stateValid
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCoverageIDChange", function (applicantObj, coverageID) {
      _this.props.debugMode && console.log('Updating Coverage ID for', applicantObj, ':', coverageID);

      _this.setState(function (prevState) {
        var _ref;

        return _ref = {}, _ref[applicantObj] = _extends({}, prevState[applicantObj], {
          coverageID: parseInt(coverageID) ? coverageID : null
        }), _ref;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdateBirthday", function (applicantObj, birthday) {
      _this.props.debugMode && console.log('Updating Birthday for', applicantObj, ':', birthday);

      switch (applicantObj) {
        case "primaryApplicant":
          {
            _this.setState(function (prevState) {
              return {
                primaryApplicant: _extends({}, prevState.primaryApplicant, {
                  birthday: birthday,
                  additionalApplicants: null
                }),
                secondaryApplicant: SharedUtils.copyObj(initialState.secondaryApplicant),
                tertiaryApplicant: SharedUtils.copyObj(initialState.tertiaryApplicant),
                verified: _extends({}, prevState.verified, {
                  primaryApplicantBirthday: prevState.verified.primaryApplicantBirthday !== null ? false : null,
                  secondaryApplicantBirthday: null,
                  tertiaryApplicantBirthday: null
                })
              };
            });
          }

        case "secondaryApplicant":
          {
            _this.setState(function (prevState) {
              return {
                secondaryApplicant: _extends({}, prevState.secondaryApplicant, {
                  birthday: birthday,
                  coverageID: null,
                  additionalApplicants: null
                }),
                tertiaryApplicant: SharedUtils.copyObj(initialState.tertiaryApplicant),
                verified: _extends({}, prevState.verified, {
                  secondaryApplicantBirthday: prevState.verified.secondaryApplicantBirthday !== null ? false : null,
                  tertiaryApplicantBirthday: null
                })
              };
            });
          }

        case "tertiaryApplicant":
          {
            _this.setState(function (prevState) {
              return {
                tertiaryApplicant: _extends({}, prevState.tertiaryApplicant, {
                  birthday: birthday,
                  coverageID: null,
                  additionalApplicants: null
                }),
                verified: _extends({}, prevState.verified, {
                  tertiaryApplicantBirthday: prevState.verified.tertiaryApplicantBirthday !== null ? false : null
                })
              };
            });
          }
      } // Only attempt to validate the birthday from the update function if birthday is fully filled out


      if (birthday.indexOf('_') === -1 || _this.state.verified[applicantObj + "Birthday"] !== null) {
        _this.handleValidateBirthday(applicantObj, birthday);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleValidateBirthday", function (applicantObj, birthday) {
      var birthdayValid = Utils.validateDate(birthday);
      var isSenior = birthdayValid ? Utils.isSenior(birthday) : null;
      var coverageID = birthdayValid && isSenior ? 1 : _this.state[applicantObj].coverageID;
      var errorMessage = null; // Ensure birthday is younger than the immediate previous

      if (birthdayValid) {
        switch (applicantObj) {
          case "secondaryApplicant":
            {
              // Ensure birthday is younger than the Primary Applicant's birthday
              var primaryApplicantBirthday = _this.state.primaryApplicant.birthday;

              if (new Date(birthday) < new Date(primaryApplicantBirthday)) {
                birthdayValid = false;
                errorMessage = "Standard application birthdays cannot exceed the oldest birthday inputted on the previous step of the application: " + Utils.getAge(primaryApplicantBirthday);
              }

              break;
            }

          case "tertiaryApplicant":
            {
              // Ensure birthday is young enough to be a child-only plan
              if (Utils.getAge(birthday) > 23) {
                birthdayValid = false;
                errorMessage = "Eldest individual on a child-only plan must be under 23 years of age";
              }

              break;
            }
        }
      }

      _this.props.debugMode && console.log("Validating Birthday for " + applicantObj, ': ', birthdayValid);
      return _this.setState(function (prevState) {
        var _extends2, _ref2;

        return _ref2 = {}, _ref2[applicantObj] = _extends({}, prevState[applicantObj], {
          isSenior: isSenior,
          coverageID: coverageID
        }), _ref2.verified = _extends({}, prevState.verified, (_extends2 = {}, _extends2[applicantObj + "Birthday"] = birthdayValid, _extends2)), _ref2.errorMessage = errorMessage, _ref2;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdateMaritalStatus", function (maritalStatus) {
      _this.props.debugMode && console.log('Updating Marital Status', maritalStatus);

      _this.setState(function (prevState) {
        return {
          primaryApplicant: _extends({}, prevState.primaryApplicant, {
            maritalStatus: maritalStatus
          }),
          verified: _extends({}, prevState.verified, {
            maritalStatus: prevState.verified.maritalStatus !== null ? false : null
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateMaritalStatus", function (maritalStatus) {
      var maritalStatusValid = false;
      if (maritalStatus && maritalStatus !== null) maritalStatusValid = true;
      _this.props.debugMode && console.log("Marital Status Valid?", maritalStatusValid);
      return _this.setState(function (prevState) {
        return {
          verified: _extends({}, prevState.verified, {
            primaryApplicantMaritalStatus: maritalStatusValid
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFetchPrices", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _this$state, zipCode, state, primaryApplicant, muleApiUrl, muleConfig, primaryApplicantPlanOptions, secondaryApplicantPlanOptions, tertiaryApplicantPlanOptions, primaryApplicantDOB, secondaryApplicant, secondaryApplicantAge, tertiaryApplicant, tertiaryApplicantAge;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _this$state = _this.state, zipCode = _this$state.zipCode, state = _this$state.state, primaryApplicant = _this$state.primaryApplicant;
                muleApiUrl = _this.props.muleApiUrl;
                muleConfig = {
                  auth: {
                    username: _this.props.muleClientId,
                    password: _this.props.muleClientSecret
                  },
                  headers: {
                    "access-control-allow-origin": "*"
                  }
                };
                tertiaryApplicantPlanOptions = null;

                _this.setState(function (prevState) {
                  return {
                    primaryApplicant: _extends({}, prevState.primaryApplicant, {
                      planOptions: []
                    }),
                    secondaryApplicant: _extends({}, prevState.secondaryApplicant, {
                      planOptions: []
                    }),
                    tertiaryApplicant: _extends({}, prevState.tertiaryApplicant, {
                      planOptions: []
                    }),
                    isFetchingPlans: true
                  };
                }); // const primaryApplicantAge = Utils.getAge(primaryApplicant.birthday);


                primaryApplicantDOB = SharedUtils.formatDate(primaryApplicant.birthday); // Fetch PRIMARY applicant plan options

                _context.next = 9;
                return Utils.fetchPrices(muleApiUrl, muleConfig, primaryApplicantDOB, primaryApplicant.coverageID, state, zipCode, primaryApplicant.maritalStatus);

              case 9:
                primaryApplicantPlanOptions = _context.sent;

                _this.setState(function (prevState) {
                  return {
                    primaryApplicant: _extends({}, prevState.primaryApplicant, {
                      planOptions: primaryApplicantPlanOptions.programs[0].programLevels
                    })
                  };
                });

                if (!primaryApplicant.additionalApplicants) {
                  _context.next = 25;
                  break;
                }

                secondaryApplicant = _this.state.secondaryApplicant;
                secondaryApplicantAge = Utils.getAge(secondaryApplicant.birthday); // Fetch SECONDARY applicant plan options

                _context.next = 16;
                return Utils.fetchPrices(muleApiUrl, muleConfig, secondaryApplicantAge, secondaryApplicant.coverageID, state, zipCode);

              case 16:
                secondaryApplicantPlanOptions = _context.sent;

                _this.setState(function (prevState) {
                  return {
                    secondaryApplicant: _extends({}, prevState.secondaryApplicant, {
                      planOptions: secondaryApplicantPlanOptions
                    })
                  };
                });

                if (!secondaryApplicant.additionalApplicants) {
                  _context.next = 25;
                  break;
                }

                tertiaryApplicant = _this.state.tertiaryApplicant;
                tertiaryApplicantAge = Utils.getAge(tertiaryApplicant.birthday); // Fetch SECONDARY applicant plan options

                _context.next = 23;
                return Utils.fetchPrices(muleApiUrl, muleConfig, tertiaryApplicantAge, tertiaryApplicant.coverageID, state, zipCode);

              case 23:
                tertiaryApplicantPlanOptions = _context.sent;

                _this.setState(function (prevState) {
                  return {
                    tertiaryApplicant: _extends({}, prevState.tertiaryApplicant, {
                      planOptions: tertiaryApplicantPlanOptions
                    })
                  };
                });

              case 25:
                _this.setState({
                  isFetchingPlans: false
                });

                return _context.abrupt("return", _this.handleFetchedPrices());

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleFetchedPrices", function () {
      var _this$state2 = _this.state,
          primaryApplicant = _this$state2.primaryApplicant,
          secondaryApplicant = _this$state2.secondaryApplicant,
          tertiaryApplicant = _this$state2.tertiaryApplicant;
      return _this.props.onPlanOptionsFetched({
        primaryApplicant: [].concat(primaryApplicant.planOptions),
        secondaryApplicant: [].concat(secondaryApplicant.planOptions),
        tertiaryApplicant: [].concat(tertiaryApplicant.planOptions)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateAdditionalApplicants", function (applicantObj, additionalApplicants) {
      _this.props.debugMode && console.log("Updating Additional Applicants for " + applicantObj, ': ', additionalApplicants);

      switch (applicantObj) {
        case "primaryApplicant":
          {
            _this.setState(function (prevState) {
              return {
                primaryApplicant: _extends({}, prevState.primaryApplicant, {
                  additionalApplicants: additionalApplicants
                }),
                secondaryApplicant: SharedUtils.copyObj(initialState.secondaryApplicant),
                tertiaryApplicant: SharedUtils.copyObj(initialState.tertiaryApplicant),
                verified: _extends({}, prevState.verified, {
                  secondaryApplicantBirthday: null,
                  tertiaryApplicantBirthday: null
                })
              };
            });
          }

        case "secondaryApplicant":
          {
            _this.setState(function (prevState) {
              return _extends({}, prevState, {
                secondaryApplicant: _extends({}, prevState.secondaryApplicant, {
                  additionalApplicants: additionalApplicants
                }),
                tertiaryApplicant: SharedUtils.copyObj(initialState.tertiaryApplicant),
                verified: _extends({}, prevState.verified, {
                  tertiaryApplicantBirthday: null
                })
              });
            });
          }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMoreApplicantsQuestionUI", function (applicantObj, index) {
      var _this$state$applicant = _this.state[applicantObj],
          additionalApplicants = _this$state$applicant.additionalApplicants,
          coverageID = _this$state$applicant.coverageID; // Only supports Medi-Share pricing for now

      var isSenior = false;
      return applicantObj !== "tertiaryApplicant" && isSenior ? /*#__PURE__*/React.createElement("div", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 372,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement("span", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 373,
          columnNumber: 9
        }
      }, "Are there more people applying?"), /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-toggle",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 374,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        name: "more-people-applying-yes-" + index,
        onClick: function onClick() {
          return _this.updateAdditionalApplicants(applicantObj, true);
        },
        className: "pricing-form-toggle-button " + (additionalApplicants === true && "selected"),
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 375,
          columnNumber: 11
        }
      }, "Yes"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        name: "more-people-applying-no-" + index,
        onClick: function onClick() {
          return _this.updateAdditionalApplicants(applicantObj, false);
        },
        className: "pricing-form-toggle-button " + (additionalApplicants === false && "selected"),
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 384,
          columnNumber: 11
        }
      }, "No"))) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBasicInfoUI", function () {
      var _this$state3 = _this.state,
          zipCode = _this$state3.zipCode,
          state = _this$state3.state,
          primaryApplicant = _this$state3.primaryApplicant,
          verified = _this$state3.verified,
          coverageID = _this$state3.coverageID;
      var _this$props = _this.props,
          muleApiUrl = _this$props.muleApiUrl,
          muleClientId = _this$props.muleClientId,
          muleClientSecret = _this$props.muleClientSecret,
          showFullStateNames = _this$props.showFullStateNames,
          statesOverride = _this$props.statesOverride,
          onStatesFetched = _this$props.onStatesFetched;
      return /*#__PURE__*/React.createElement(Fragment, {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 419,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-field",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 420,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("label", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 421,
          columnNumber: 11
        }
      }, "How Many People Are Applying?"), /*#__PURE__*/React.createElement("select", {
        name: "number-of-people",
        value: coverageID,
        onChange: function onChange(e) {
          return _this.handleCoverageIDChange('primaryApplicant', parseInt(e.target.value));
        },
        required: true,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 422,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: 1,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 430,
          columnNumber: 13
        }
      }, "1"), /*#__PURE__*/React.createElement("option", {
        value: 2,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 431,
          columnNumber: 13
        }
      }, "2"), /*#__PURE__*/React.createElement("option", {
        value: 3,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 432,
          columnNumber: 13
        }
      }, "3 or more"))), /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-field",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 436,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("label", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 437,
          columnNumber: 11
        }
      }, "Date of birth of oldest person applying:"), /*#__PURE__*/React.createElement(NumberFormat, {
        name: "primary-birthday",
        value: primaryApplicant.birthday,
        placeholder: "MM/DD/YYYY",
        format: "##/##/####",
        mask: "_",
        onValueChange: function onValueChange(change) {
          return _this.handleUpdateBirthday("primaryApplicant", change.formattedValue);
        },
        onBlur: function onBlur(e) {
          return _this.handleValidateBirthday("primaryApplicant", e.target.value);
        },
        style: {
          border: verified.primaryApplicantBirthday === false ? "2px solid red" : ""
        },
        required: true,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 438,
          columnNumber: 11
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-field",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 455,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("label", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 456,
          columnNumber: 11
        }
      }, "Marital Status:"), /*#__PURE__*/React.createElement("select", {
        selected: primaryApplicant.maritalStatus,
        value: primaryApplicant.maritalStatus,
        onChange: function onChange(e) {
          return _this.handleUpdateMaritalStatus(e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this.validateMaritalStatus(primaryApplicant.maritalStatus);
        },
        style: {
          borderRadius: verified.maritalStatus === false ? "state-input-invalid" : "",
          generalInputStyle: 'pricing-calculator-state-input'
        },
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 457,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "single",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 467,
          columnNumber: 13
        }
      }, "Single"), /*#__PURE__*/React.createElement("option", {
        value: "married",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 468,
          columnNumber: 13
        }
      }, "Married"), /*#__PURE__*/React.createElement("option", {
        value: "divorced",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 469,
          columnNumber: 13
        }
      }, "Divorced"), /*#__PURE__*/React.createElement("option", {
        value: "widowed",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 470,
          columnNumber: 13
        }
      }, "Widowed"))), /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-field state-field",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 474,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(StatePicker, {
        selectedState: state,
        onStateSelected: function onStateSelected(state) {
          return _this.handleUpdateState(state);
        },
        onBlur: function onBlur(state) {
          return _this.validateState(state);
        },
        muleApiUrl: muleApiUrl,
        muleClientId: muleClientId,
        muleClientSecret: muleClientSecret,
        defaultOptionText: "Please select a state...",
        showFullStateNames: showFullStateNames,
        statesOverride: statesOverride,
        onStatesFetched: onStatesFetched,
        style: {
          generalInputStyle: 'pricing-calculator-state-input'
        },
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 475,
          columnNumber: 11
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-field",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 492,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("label", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 493,
          columnNumber: 11
        }
      }, "Postal Code:"), /*#__PURE__*/React.createElement(NumberFormat, {
        name: "zip",
        placeholder: "Zip Code",
        format: "#####",
        mask: "_",
        value: zipCode,
        onValueChange: function onValueChange(change) {
          return _this.handleUpdateZipCode(change.value);
        },
        onBlur: function onBlur(e) {
          return _this.validateZipCode(e.target.value);
        },
        style: {
          border: verified.zipCode === false ? "2px solid red" : ""
        },
        required: true,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 494,
          columnNumber: 11
        }
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "handleAdditionalApplicantInfoUI", function (applicantObj, index) {
      var verified = _this.state.verified;
      var birthday = _this.state[applicantObj].birthday;
      return /*#__PURE__*/React.createElement(Fragment, {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 515,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "pricing-form-field",
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 516,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("label", {
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 517,
          columnNumber: 11
        }
      }, "Birthday of the next oldest person applying"), /*#__PURE__*/React.createElement(NumberFormat, {
        autoFocus: true,
        name: (index === 2 ? 'secondary' : 'tertiary') + "-birthday",
        value: birthday,
        placeholder: "MM/DD/YYYY",
        format: "##/##/####",
        mask: "_",
        onValueChange: function onValueChange(change) {
          return _this.handleUpdateBirthday(applicantObj, change.formattedValue);
        },
        onBlur: function onBlur(e) {
          return _this.handleValidateBirthday(applicantObj, e.target.value);
        },
        style: {
          border: verified[applicantObj + "Birthday"] === false ? "2px solid red" : ""
        },
        required: true,
        __self: _assertThisInitialized(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 518,
          columnNumber: 11
        }
      })));
    });

    _this.state = SharedUtils.copyObj(initialState);
    return _this;
  }

  var _proto = PricingCalculator.prototype;

  _proto.checkIfPlansCanBeFetched = function checkIfPlansCanBeFetched() {
    var _this$state4 = this.state,
        isFetchingPlans = _this$state4.isFetchingPlans,
        verified = _this$state4.verified,
        primaryApplicant = _this$state4.primaryApplicant,
        secondaryApplicant = _this$state4.secondaryApplicant,
        tertiaryApplicant = _this$state4.tertiaryApplicant; // Check if we are currently fetching prices

    if (isFetchingPlans) return false; // Check that Zip Code and State are verified

    if (!verified.zipCode) return false; // Check that all information for PRIMARY Applicant are verified / collected

    if (!verified.primaryApplicantBirthday) return false;
    if (!primaryApplicant.isSenior && primaryApplicant.coverageID === null) return false; // Remove Senior Assist support for now
    // if (primaryApplicant.isSenior && primaryApplicant.additionalApplicants === null) return false;
    // Check that all information for SECONDARY Applicant are verified / collected

    if (primaryApplicant.additionalApplicants) {
      if (!verified.secondaryApplicantBirthday) return false;
      if (!secondaryApplicant.isSenior && secondaryApplicant.coverageID === null) return false;
      if (secondaryApplicant.isSenior && secondaryApplicant.additionalApplicants === null) return false;
    } // Check that all information for SECONDARY Applicant are verified / collected


    if (secondaryApplicant.additionalApplicants) {
      if (!verified.tertiaryApplicantBirthday) return false;
      if (tertiaryApplicant.coverageID === null) return false;
    }

    return true;
  };

  _proto.render = function render() {
    var _this$state5 = this.state,
        primaryApplicant = _this$state5.primaryApplicant,
        secondaryApplicant = _this$state5.secondaryApplicant,
        verified = _this$state5.verified,
        errorMessage = _this$state5.errorMessage,
        isFetchingPlans = _this$state5.isFetchingPlans;
    return /*#__PURE__*/React.createElement("div", {
      className: "ccm-pricing-calculator-wrapper",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 586,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 587,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("form", {
      className: "pricing-form-grid",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 588,
        columnNumber: 11
      }
    }, this.handleBasicInfoUI(), verified.zipCode && verified.state && verified.primaryApplicantBirthday && this.handleMoreApplicantsQuestionUI("primaryApplicant", 1)), verified.primaryApplicantBirthday === true && primaryApplicant.additionalApplicants === true && /*#__PURE__*/React.createElement("div", {
      className: "additional-applicant-grid",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 601,
        columnNumber: 13
      }
    }, this.handleAdditionalApplicantInfoUI("secondaryApplicant", 2), verified.secondaryApplicantBirthday && this.handleMoreApplicantsQuestionUI("secondaryApplicant", 2), errorMessage && secondaryApplicant.additionalApplicants !== true && /*#__PURE__*/React.createElement("div", {
      className: "error-message-grid",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 612,
        columnNumber: 17
      }
    }, errorMessage)), verified.secondaryApplicantBirthday === true && secondaryApplicant.additionalApplicants === true && /*#__PURE__*/React.createElement("div", {
      className: "additional-applicant-grid",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 622,
        columnNumber: 13
      }
    }, this.handleAdditionalApplicantInfoUI("tertiaryApplicant", 3), verified.tertiaryApplicantBirthday && this.handleMoreApplicantsQuestionUI("tertiaryApplicant", 3), errorMessage && /*#__PURE__*/React.createElement("div", {
      className: "error-message-grid",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 632,
        columnNumber: 17
      }
    }, errorMessage)), /*#__PURE__*/React.createElement("button", {
      onClick: this.handleFetchPrices,
      className: "pricing-form-button",
      disabled: !this.checkIfPlansCanBeFetched(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 639,
        columnNumber: 11
      }
    }, isFetchingPlans ? "Finding Plans..." : "See Your Pricing")));
  };

  return PricingCalculator;
}(Component);

export { PricingCalculator as default };
var initialState = {
  // shared details
  zipCode: null,
  state: 'AL',
  // primary details
  primaryApplicant: {
    birthday: null,
    maritalStatus: 'single',
    isSenior: null,
    additionalApplicants: null,
    coverageID: 1,
    planOptions: []
  },
  // secondary details
  secondaryApplicant: {
    birthday: null,
    isSenior: null,
    additionalApplicants: null,
    coverageID: null,
    planOptions: []
  },
  // tertiary details
  tertiaryApplicant: {
    birthday: null,
    coverageID: null,
    planOptions: []
  },
  // verification
  verified: {
    zipCode: null,
    primaryApplicantBirthday: null,
    secondaryApplicantBirthday: null,
    tertiaryApplicantBirthday: null
  },
  // miscellaneous
  errorMessage: "",
  isFetchingPlans: false
};
PricingCalculator.defaultProps = {
  debugMode: false,
  statesOverride: null,
  showFullStateNames: false,
  hideStateDefaultText: false
};
PricingCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: PropTypes.string.isRequired,
  onPlanOptionsFetched: PropTypes.func.isRequired,
  debugMode: PropTypes.bool,
  showFullStateNames: PropTypes.bool,
  statesOverride: PropTypes.array,
  onStatesFetched: PropTypes.func,
  hideStateDefaultText: PropTypes.bool
} : {};